import Input from "components/atoms/input/Input";
import { ModalInput } from "components/atoms/input/modal/ModalInput";
import BigPopupTemplate from "components/templates/modal/big/BigPopupTemplate";
import * as s from "../LyveStyled";
import BigButton from "components/atoms/buttons/BigButton";
import TextArea from "components/atoms/input/TextArea";
import { IoMdCopy } from "react-icons/io";
import { handleCopyClipBoard } from "utils/functions";
import { LicenseDetailData } from "api/interfaces/subscription.interface";
import { useMemo, useState } from "react";
import { ValidateMsg } from "api/interfaces/commonInterface.interface";
import SuccessModal from "../add/SuccessModal";
import SelectComponent from "components/atoms/select/SelectComponent";
import { cumulusPartNumberOptions } from "utils/options";
import useApiError from "hook/useApiError";

type Props = {
  onModal: () => void;
  data: LicenseDetailData | undefined;
  onChangePartNumber: (option: string) => void;
  updatedKey: string;
  originalOption: string;
  duration: number;
  type: string;
};

export default function ViewLyveModal(props: Props) {
  const [partNumber, setPartNumber] = useState<string>(
    props?.data?.part_number || ""
  );
  const { intlString, lang } = useApiError();
  const [validateMsg, setValidateMsg] = useState<ValidateMsg>({
    size: "",
  });
  const options = useMemo(() => {
    return cumulusPartNumberOptions.filter((option) =>
      option.value.includes(`${props.duration * 12}M`)
    );
  }, [props.duration]);
  const onClickSave = () => {
    if (
      partNumber === "" ||
      options.findIndex((option) => option.value === partNumber) === -1
    ) {
      setValidateMsg((prev: ValidateMsg) => ({
        ...prev,
        size: intlString(lang.label.lyve.generateKey.partNumber.required),
      }));
      return;
    }
    if (partNumber === props.originalOption) {
      setValidateMsg((prev: ValidateMsg) => ({
        ...prev,
        size: intlString(lang.label.lyve.generateKey.partNumber.same),
      }));
      return;
    }
    props.onChangePartNumber(partNumber);
  };
  if (!props.data) return null;
  return (
    <BigPopupTemplate title="Subscription Key Detail" onModal={props.onModal}>
      {props.updatedKey !== "" ? (
        <SuccessModal
          subscriptionKey={props.updatedKey}
          onCopy={() =>
            handleCopyClipBoard(props.updatedKey, "Subscription Key")
          }
          onModal={props.onModal}
        />
      ) : (
        <>
          <s.ViewLyveModalContainer>
            <ModalInput label="Subscription Key">
              <TextArea
                value={props.data.subscription_key}
                disabled={true}
                style={{ height: 150 }}
              />

              <s.CopyButton
                onClick={() =>
                  handleCopyClipBoard(
                    props.data?.subscription_key || "",
                    "Subscription Key"
                  )
                }
                data-testid="subscription-lyve-view-copy-button-copy-clip-board"
              >
                <IoMdCopy />
              </s.CopyButton>
            </ModalInput>
            <ModalInput label="Bucket Name">
              <Input value={props.data.bucket_name} disabled={true} />
            </ModalInput>
            <ModalInput
              label="Stock Keeping Unit (SKU)"
              isValidated={validateMsg.size ? true : false}
              validatedWord={validateMsg.size}
            >
              <s.FormStorage>
                <SelectComponent
                  options={options}
                  placeholder="Select Stock Keeping Unit (SKU)"
                  value={partNumber}
                  disabled={!props.data.is_active}
                  onChange={(value) => setPartNumber(value as string)}
                  data-testid="subscription-lyve-view-selects-set-part-number"
                />
              </s.FormStorage>
            </ModalInput>
            <ModalInput label="Access Key ID">
              <Input value={props.data.access_key_id} disabled={true} />
              <s.CopyButton
                onClick={() =>
                  handleCopyClipBoard(
                    props.data?.access_key_id || "",
                    "Access Key ID"
                  )
                }
                data-testid="subscription-lyve-view-copy-button-copy-clip-board-2"
              >
                <IoMdCopy />
              </s.CopyButton>
            </ModalInput>
            <ModalInput label="Secret Key">
              <TextArea value={props.data.secret_key} disabled={true} />
              <s.CopyButton
                onClick={() =>
                  handleCopyClipBoard(
                    props.data?.secret_key || "",
                    "Secret Key"
                  )
                }
                data-testid="subscription-lyve-view-copy-button-copy-clip-board-3"
              >
                <IoMdCopy />
              </s.CopyButton>
            </ModalInput>
            <ModalInput label="End Point URL">
              <Input value={props.data.endpoint_url} disabled={true} />
              <s.CopyButton
                onClick={() =>
                  handleCopyClipBoard(
                    props.data?.endpoint_url || "",
                    "End Point URL"
                  )
                }
                data-testid="subscription-lyve-view-copy-button-copy-clip-board-4"
              >
                <IoMdCopy />
              </s.CopyButton>
            </ModalInput>
          </s.ViewLyveModalContainer>
          <s.StepButtonContainer>
            <BigButton
              label={props.data.is_active ? "Cancel" : "Close"}
              buttonType="cancel"
              onClickBtn={props.onModal}
              data-testid="subscription-lyve-view-button-modal"
            />

            {props.data.is_active && (
              <BigButton
                label="Save"
                buttonType="primary"
                onClickBtn={onClickSave}
                disabled={!props.data.is_active}
                data-testid="subscription-lyve-view-button-click-save"
              />
            )}
          </s.StepButtonContainer>
        </>
      )}
    </BigPopupTemplate>
  );
}
